import { useCallback } from 'react';
import Cookies from 'js-cookie';

export const usePageVisitData = () => {
  const getVisitData = () => {
    if (typeof window === 'undefined') {
      return {
        sid: null,
        entryURL: null,
        referer: null,
      };
    }

    // Сохраняем исходный URL при первом визите
    let initialEntryURL = sessionStorage.getItem('initialEntryURL');
    if (!initialEntryURL) {
      initialEntryURL = window.location.href;
      sessionStorage.setItem('initialEntryURL', initialEntryURL);
    }

    const sid = Cookies.get('sessionId');
    const referer = document.referrer;

    return {
      sid,
      entryURL: initialEntryURL,
      referer,
    };
  };

  const { sid, entryURL, referer } = getVisitData();

  const getPattern = useCallback(() => {
    return JSON.stringify(['login', { sid, entryURL, referer }]);
  }, [sid, entryURL, referer]);

  return {
    getPattern,
    sid,
    entryURL,
    referer,
  };
};
